<template>
  <!-- 充值记录 -->
  <div class="el-card pd20">
    <div class="main">
      <div class="box">
        <!--  -->
        <div class="search">
          <div class="search-gropu">
            商品
            <el-select class="search-child"  v-model="product_id" placeholder="请选择测评" clearable>
              <el-option v-for="(item,index) in productList" :key="index" :label="item.name" :value="item.id">{{item.name}}</el-option>
            </el-select>
          </div>
          <!--  -->
          <div class="search-gropu on">
            类型
            <el-select class="search-child"  v-model="type" placeholder="请选择类型" clearable>
              <el-option label="后台充值" :value="1">后台充值</el-option>
              <el-option label="链接购买" :value="2">链接购买</el-option>
            </el-select>
          </div>
          <el-button type="primary" @click="pullData" size="medium">搜索</el-button>
          <el-button type="primary" @click="timeBool = true" size="medium">导出数据</el-button>
        </div>
        <!--  -->
        <!-- <div class="search search-btn"></div> -->
      </div>
      <!-- list-->
      <div class="el-card pd20">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="user_name" label="用户姓名"></el-table-column>
          <el-table-column prop="product_name" label="商品名称"></el-table-column>
          <el-table-column prop="count" label="数量"></el-table-column>
          <el-table-column  label="类型">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.type==1" type="success" effect="dark">后台充值</el-tag>
              <el-tag  v-if="scope.row.type==2"   effect="dark">链接购买</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="ctime" label="时间"> </el-table-column>
        </el-table>
      </div>
      <!-- 添加按钮 -->
      <!-- <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus"  @click="addGraph" circle></el-button> -->
      <!-- 分页 -->
      <el-pagination class="pages" :page-sizes="[25, 50, 75, 100]" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pages.size" :current-page="pages.page" background layout="sizes,prev, pager, next" :total="pages.count"></el-pagination>
      <!-- -->
      <!-- <div class="pages-box"></div>  -->
    </div>
    <el-dialog title="请选择时间段" :visible.sync="timeBool">
      <el-form  >
          <el-form-item label="日期" :label-width="formLabelWidth">
              <el-date-picker
                v-model="time"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right">
              </el-date-picker>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="timeBool = false">取 消</el-button>
          <el-button type="primary" @click="exportExcelHandle()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { chargeLogList, productAll, chargeLogAll} from "@/api/measurement";
import { exportExcel} from "@u/tools";
export default {
  data() {
      return {
        list: [],
        pages: {},
        productList:[],
        type: null,
        product_id: null,
        obj: {},
        timeBool:false,
        time:[],
      }
    },
    methods: {
      // 调整每页显示条数
      handleSizeChange(val) {
        this.pages.size = val;
        this.pullData();
      },
      // 触发分页
      handleCurrentChange(val) {
        this.pages.page = val;
        this.pullData();
      },
      //导出的方法
      exportExcelHandle() {
        let h = [
          '用户姓名',
          '商品名称',
          '数量',
          '类型',
          '时间'
        ];
        let b = ['user_name', 'product_name','count','type','ctime'];
        if(this.time.length==2){
            this.obj['start_time']=this.time[0];
            this.obj['end_time']=this.time[1];
          }
        chargeLogAll(this.obj).then((res) => {
          if(res.error>0){
            this.$message(res.msg);
            return
          }
          let list = res.list; 
          for(let i=0;i<list.length;i++){
            if(list[i].type==1){
              list[i].type='后台充值';
            }else if(list[i].type==2){
              list[i].type='链接购买';
            }
            
          }
          exportExcel(h, b,list, '购买记录导出');
          this.timeBool = false;
        })

      },
      pullData() {
        this.$showLoading();
        if(this.productList.length==0){
          productAll().then((res)=>{
            this.productList = res.list;
          });
        }

        this.obj = {
          page: Object.keys(this.pages).length > 0 ? this.pages.page : 1, //页码，默认1
          size: Object.keys(this.pages).length > 0 ? this.pages.size : 25 //每页数量，默认25
        };
        // 判断如果有值为真的情况下传参,否则不传
        if (this.product_id) {
          this.obj['product_id'] = this.product_id;
        }
        if (this.type) {
          this.obj['type'] = this.type;
        }
        chargeLogList(this.obj).then((data) => {
          if(data.error>0){
            this.$message(data.msg);
            return
          }
          this.list = data.list;
          this.pages = data.pager;
          this.$hideLoading();
        }).catch((err) => {
          this.$hideLoading();
        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.main {
  position: relative;
}

.addBtn {
  position: absolute;
  left: 0;
  bottom: 0;
}

.pages {
  text-align: right;
  margin-top: 30px;
}

.pages-box {
  height: 32px;
  margin-top: 30px;
}

.preview {
  width: 300px;
  border-radius: 5px;
}

.box {
  margin-bottom: 20px;
}

.search {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.search.search-btn {
  flex: 1;
}

.search-gropu {
  flex: 1;
}

.search-gropu.on {
  flex: 1.5;
}

.search-child {
  margin-left: 20px;
  width: 200px;
}

.userinfo {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }
}
.extra-h4{
  margin:10px auto;
  line-height:20px;
}
</style>
<style lang="scss">
.buy-time {
  input {
    background-color: transparent !important;
    width: 60% !important;
  }
}

.buy-time.el-date-editor.el-input,
.buy-time.el-date-editor.el-input__inner {
  margin-left: 20px;
}
</style>
